export default {
  props: {
    type: Number,
    message: String
  },
  computed: {
    verifyType() {
      if (this.type == 1) {
        return this.$t("Phone No.");
      } else if (this.type == 2) {
        return this.$t("Email");
      } else if (this.type == 3) {
        return this.$t("Member No.");
      }

      return "";
    }

  }
};